import { Container, Content, Title, Subtitle, Middle, Right, Left } from './styles';

const Header = (props) => (
  <Container shadow={props.shadow}>
    <Content className="header-content">
      <Left>
        <Title>{props.title}</Title>
        {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
      </Left>
      <Middle visible={Boolean(props.middleContent)}>{props.middleContent}</Middle>
      <Right>{props.children}</Right>
    </Content>
  </Container>
);

Header.defaultProps = {
  subtitle: null,
  shadow: false,
  children: null,
  middleContent: null,
};

export default Header;
